var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30522 0.809487L9.35093 0.849156L13.5281 4.58005C13.533 4.58429 13.5378 4.58861 13.5425 4.593L14.8619 5.77153C15.1045 5.98818 15.1259 6.3609 14.9098 6.60404C14.7019 6.83782 14.3502 6.86666 14.1078 6.67594L14.0792 6.652L13.7321 6.34189L13.7322 11.0053C13.7322 12.4548 12.5762 13.6334 11.1379 13.6659L11.0769 13.6666H4.92321C3.47682 13.6666 2.30098 12.5082 2.2686 11.0664L2.26791 11.0053L2.26783 6.34169L1.92074 6.652C1.67818 6.86864 1.30635 6.84717 1.09022 6.60404C0.882409 6.37025 0.894221 6.01666 1.11107 5.7972L1.13807 5.77153L2.46041 4.59043C2.46299 4.58807 2.4656 4.58574 2.46822 4.58343L6.64905 0.849152C7.40408 0.174782 8.53593 0.161559 9.30522 0.809487ZM7.46581 1.70072C7.14239 1.96085 7.43172 1.72962 7.43172 1.72962L3.4443 5.29091L3.44438 11.0053C3.44438 11.808 4.08047 12.4612 4.87533 12.4865L4.92321 12.4873H11.0769C11.8777 12.4873 12.5297 11.8496 12.555 11.0533L12.5558 11.0053L12.5557 5.2911L8.56811 1.72949C8.25567 1.45022 7.78922 1.44059 7.46581 1.70072Z",
    fill: "#A5A0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTabIcon);
export default __webpack_public_path__ + "static/media/home-tab-icon.f969de584b7f98255f751add6276970f.svg";
export { ForwardRef as ReactComponent };